<template>
  <div id="faz-arbeitslosenzahlen" v-if="!loading">
    <h2 class="headline">Der Arbeitsmarkt in Deutschland</h2>
    <p class="subheadline">Stand: {{ date.monthName }} {{ date.year }}</p>
    <div class="cols">
      <div class="col">
        <!-- <div class="grid-y"> -->
          <div class="overlineBox">
            <div class="cols">
              <div class="col small">
                <div class="headline"><b>Arbeitslosen&shy;quote</b></div>
                <div class="number"><b> {{ arbeitslosenquote[0] }}%</b></div>
              </div>
              <div class="col small">
                <div class="headline">Veränderung zum Vorjahr*</div>
                <div class="number"><span v-bind:class="arbeitslosenquote[2]">{{ arbeitslosenquote[1] }}</span></div>
              </div>
            </div>
          </div>
          <div class="overlineBox">
            <div class="cols">
              <div class="col small">
                <div class="headline">Westdeutschland</div>
                <div class="number_small"><b> {{ ostwest.west[0] }}% </b> <span v-bind:class="ostwest.west[2]">{{ ostwest.west[1] }}</span></div>
              </div>
              <div class="col small">
                <div class="headline">Ostdeutschland</div>
                <div class="number_small"><b>{{ ostwest.ost[0] }}% </b> <span v-bind:class="ostwest.ost[2]">{{ ostwest.ost[1] }}</span></div>
              </div>
            </div>
          </div>
          <!-- <div class="cell"> -->
            <div class="bundeslaender">
              <choropleth v-if="map" :map="map" v-model="hover" ></choropleth>
              <div class="tooltip" v-if="hover" :style="{'left': hover.x + 15 + 'px', 'top': hover.y + 'px'}">
                <span class="tooltip_headline">{{hover.name}}</span>
                <div>Arbeitslosenquote:<br>{{hover.quote}}% ({{blDate}})</div>
              </div>
            </div>
          <!-- </div> -->
        <!-- </div> -->
      </div>
      <div class="col">
        <!-- <div class="grid-y"> -->
          <div class="overlineBox">
            <div class="cols">
              <div class="col small">
                <div class="headline"><b>Arbeitslose</b></div>
                <div class="number"><b>{{ arbeitslose[0] }}</b> <small> Mio.</small></div>
              </div>
              <div class="col small">
                <div class="headline">Veränderung zum Vorjahr</div>
                <div class="number"><span v-bind:class="arbeitslose[2]">{{ arbeitslose[1] }}%</span></div>
              </div>
            </div>
            <GChart
              class="gchart"
              type="LineChart"
              :settings="{ packages: ['corechart'], language: 'de' }"
              :data="arbeitsloseData"
              :options="chartOptions1"
              @ready="onChartReady"
            />
          </div>
          <div class="overlineBox">
            <div class="cols">
              <div class="col small">
                <div class="headline"><b>Offene Stellen</b></div>
                <div class="number"><b>{{ stellen[0] }}</b> <small> Tsd.</small></div>
              </div>
              <div class="col small">
                <div class="headline">Veränderung zum Vorjahr</div>
                <div class="number"><span v-bind:class="stellen[2]">{{ stellen[1] }}%</span></div>
              </div>
            </div>
            <GChart
              class="gchart"
              type="LineChart"
              :settings="{ packages: ['corechart'], language: 'de' }"
              :data="stellenData"
              :options="chartOptions2"
            />
          </div>
          <div class="cell overlineBox">
            <div class="cols">
              <div class="col small">
                <div class="headline"><b>Erwerbs&shy;tätige</b></div>
                <div class="number"><b>{{ taetige[0] }}</b> <small> Mio.</small></div>
              </div>
              <div class="col small">
                <div class="headline">Veränderung zum Vorjahr</div>
                <div class="number"><span v-bind:class="taetige[2]">{{ taetige[1] }}%</span></div>
              </div>
            </div>
            <GChart v-if="showCharts"
              class="gchart"
              type="LineChart"
              :settings="{ packages: ['corechart'], language: 'de' }"
              :data="erwerbstaetigeData"
              :options="chartOptions3"
            />
          </div>
        <!-- </div> -->
      </div>
    </div>
    <p class="footnote">*) Veränderung in Prozentpunkten / Grafik: jpg. / Quellen: Statistisches Bundesamt, Bundesagentur für Arbeit</p>
  </div>
</template>

<script>
import {csvParse} from 'd3'
import {csvParseRows} from 'd3'
// import {timeParse} from 'd3'
import {format} from 'd3'
// import {TweenLite} from 'gsap'
import { GChart } from 'vue-google-charts'
import {fetchPolyfill} from 'fetch-polyfill'

import Choropleth from './components/Choropleth.vue'

let darkmode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
console.log('DM:', darkmode)

export default {
  name: 'faz-arbeitslosenzahlen',
  components: {
    Choropleth,
    GChart
  },
  data () {
    return {
      loading: true,
      urls: {
        data: process.env.BASE_URL + 'data/R/arbeitslosenzahlen.csv',
        ostwest: process.env.BASE_URL + 'data/R/ostwest.csv',
        // ostwest: 'https://tempstoragedelivery.blob.core.windows.net/delivery/ostwest.csv?sp=rl&st=2019-12-03T21:50:55Z&se=2999-12-31T23:00:00Z&sv=2019-02-02&sr=c&sig=xfhfedvhnJTB3PV81hy13xZVfjiD1%2BxEBJasGq7nVSo%3D',
        bundeslaender: process.env.BASE_URL + 'data/R/bundeslaender.csv'
      },
      dataUrl: 'https://api.y.faz.net/spreadsheets/static/1myVOo6N80_fjRwVojl4Xe9oJdNrW_SZ7jI86KvZwRhU.json',
      spreadsheetData: null,
      data: null,
      dta: {},
      arbeitsloseData: null,
      stellenData: null,
      erwerbstaetigeData: null,
      mapUrl: process.env.BASE_URL + 'data/4_niedrig.geojson',
      map: null,
      hover: null,
      bundeslaenderData: [],
      bl: ['Schleswig-Holstein','Hamburg','Niedersachsen','Bremen','Nordrhein-Westfalen','Hessen','Rheinland-Pfalz','Baden-Württemberg','Bayern','Saarland','Berlin','Brandenburg','Mecklenburg-Vorpommern','Sachsen','Sachsen-Anhalt','Thüringen'],
      months: ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],
      showCharts: true,
      chartOptions: {
        height: 150,
        colors: ["#A82424"],
        backgroundColor: 'transparent',
        fontSize: 14,
        fontName: "'Source Sans 3', 'FAZ Gold', Helvetica, Arial, sans-serif",
        lineWidth: 3,
        curveType: 'function',
        animation: {
          startup: true,
          duration: 1000,
          easing: 'out'
        },
        hAxis: {
          gridlines: {
            color: darkmode ? '#000' : '#e3e3e3',
            count: 10
          },
          minorGridlines: {
            count: 0
          }
        }, 
        vAxis: {
          gridlines: {
            color: darkmode ? '#000' : '#e3e3e3',
            count: 5
          },
          minorGridlines: {
            count: 0
          }
        },
        legend: {
          position: 'none' 
        },
        tooltip: {
          isHtml: true
        }
      },
      chart1: {
        chartArea: {left:30,top:10,width:'90%',height:'80%'},
      },
      chart2: {
        colors: ["#C28E0A"],
        chartArea: {left:40,top:10,width:'88%',height:'70%'},
      },
      chart3: {
        colors: ["#2962A3"],
        chartArea: {left:22,top:10,width:'92%',height:'70%'},
      }
    }
  },
  mounted () {
    let fetches = [
      fetch(this.urls.data).then(r => r.text()),
      fetch(this.urls.bundeslaender).then(r => r.text()),
      fetch(this.urls.ostwest).then(r => r.text()),
      fetch(this.mapUrl).then(r => r.json()),
      fetch(this.dataUrl).then(r => r.json())
    ]
    Promise.all(fetches).then((results) => {
      // this.dta.arbeitslosenzahlen = this.parseCsv(results[0]) //.replace(/,/g,'.').replace(/;/g,',')
      // this.bundeslaenderData = this.parseBundeslaender(results[1]) //.replace(/,/g,'.').replace(/;/g,',')
      // this.dta.ostwest = this.parseOstWest(results[2])
      this.map = results[3]
      this.dta.arbeitslosenzahlen = results[4].zeitreihen //test
      this.dta.ostwest = results[4].ostwest
      this.bundeslaenderData = results[4].bundeslaender
      this.spreadsheetData = results[4]

      this.loading = false
      console.log(results[4].zeitreihen)
    })
  },
  methods: {
    onChartReady (chart, google) {
      console.log("chart ready")
      let delta = 11
      let date = new Date()
      date.setYear(date.getFullYear()-delta)

      let dateFormatter = new google.visualization.DateFormat({ pattern: "MMM yyyy" })
      var numberFormatter = new google.visualization.NumberFormat({ decimalSymbol: ',', groupingSymbol: '.' })

      let dt = new google.visualization.DataTable()
      dt.addColumn('date', 'Data')
      dt.addColumn('number', 'Arbeitslose (in Mio.)')

      dt.addRows( this.dta.arbeitslosenzahlen
        .slice(1)
        .map( el => {
          return [new Date(el[0]), Math.round(el[1]/10000)/100]
        })
        .filter( el => {
          return new Date(el[0]) > date
        })
      )

      dateFormatter.format(dt, 0)
      numberFormatter.format(dt, 1)

      this.arbeitsloseData = dt
      console.log(dt)


      dt = new google.visualization.DataTable()

      dt.addColumn('date', 'Data')
      dt.addColumn('number', 'Erwerbstätige (in Mio.)')

      dt.addRows( this.dta.arbeitslosenzahlen
        .slice(1)
        .map( el => {
          return [new Date(el[0]), parseFloat(el[4])]
        })
        .filter( el => {
          return new Date(el[0]) > date
        })
      )

      dateFormatter.format(dt, 0)
      numberFormatter.format(dt, 1)


      this.erwerbstaetigeData = dt


      dt = new google.visualization.DataTable()
      dt.addColumn('date', 'Data')
      dt.addColumn('number', 'Offene Stellen (in Tsd.)')

      dt.addRows( this.dta.arbeitslosenzahlen
        .slice(1)
        .filter( el => {
          return el[3] > 0
        })
        .map( el => {
          return [new Date(el[0]), el[3]/1000]
        })
        .filter( el => {
          return new Date(el[0]) > date
        })
      )

      console.log('dt', dt)

      numberFormatter = new google.visualization.NumberFormat({ decimalSymbol: ',', groupingSymbol: '.', fractionDigits: 0 })
      dateFormatter.format(dt, 0)
      numberFormatter.format(dt, 1)

      this.stellenData = dt

      console.log('stellenData', this.stellenData)
    },
    parseCsv (csv) {
      return csvParseRows(csv, (row, i) => {
        if (i===0) {
          return [ row[1], row[2], row[3], row[4], row[5]]
        } else {
          return [ this.parseTime(row[1]), parseInt(row[2]), parseInt(row[3]), parseFloat(row[4]), parseFloat(row[5]) ]
        }
      })
    },
    parseOstWest (csv) {
      return csvParse(csv)
    },
    parseBundeslaender (csv) {
      return csvParse(csv)
    },
    decimal (number) {
      return format(",.2r")(number).replace('.',',')
    },
    millions (number) {
      return String(Math.round(number/100000)/10).replace('.',',') + ' Mio.'
    },
    parseTime (string) {
      let d = new Date(string + '-01')
      return d
    },
    calculateChange (number) {
      let diff = null
      let change = null

      number = Math.round(number*10)/10

      if(number === 0) {
        change = 'grey'
        diff = '±' + number.toString().replace('.',',')
      } else if (number > 0) {
        change = 'green'
        diff = '-' + number.toString().replace('.',',')
      } else {
        change = 'red'
        diff = '+' + number.toString().replace('.',',').replace('-','')
      }
      return [diff, change]
    },
    isLastYear(element) {
      let date = new Date(element[0])
      return date.getFullYear() === this.date.lastYear && date.getMonth() === this.date.month
    }
  },
  watch: {
    bundeslaenderData () {
      this.map.features.forEach(f => {
        let region = null
        //region = this.bundeslaenderData.find(d => this.bl[parseInt(d[0])-1] === f.properties.NAME_1)
        region = this.bundeslaenderData.find(d => d[0] === f.properties.NAME_1)

        if (region === null) {
          f.properties.quote = 0
        } else {
          f.properties.quote = region[1].replace(',','.')
        }
      })
    },
  },
  computed: {
    date () {
      let latest = this.dta.arbeitslosenzahlen.slice(-1)[0]
      let date = new Date(latest[0])

      return {
        object: date,
        year: date.getFullYear(),
        month: date.getMonth(),
        monthName: this.months[date.getMonth()],
        lastYear: date.getFullYear()-1
      }
    },
    blDate () {
      
      return this.dta.ostwest[0][2].slice(0,3) + '. ' + this.dta.ostwest[0][1]
    },
    ostwest () {
      // let w = this.dta.ostwest.filter( el => el.region === 'DF')
      // let o = this.dta.ostwest.filter( el => el.region === 'DN')

      // let quote_w = this.decimal(w[1].arbeitslosenquote)
      // let quote_o = this.decimal(o[1].arbeitslosenquote)

      // let diff_w = parseFloat(w[0].arbeitslosenquote)-parseFloat(w[1].arbeitslosenquote)
      // let diff_o = parseFloat(o[0].arbeitslosenquote)-parseFloat(o[1].arbeitslosenquote)

      let quote_w = this.dta.ostwest[0][3]
      let quote_o = this.dta.ostwest[1][3]

      let diff_w = this.dta.ostwest[2][3] - quote_w
      let diff_o = this.dta.ostwest[3][3] - quote_o

      return {
        west: [this.decimal(quote_w), this.calculateChange(diff_w)[0], this.calculateChange(diff_w)[1] ],
        ost: [this.decimal(quote_o), this.calculateChange(diff_o)[0], this.calculateChange(diff_o)[1] ]
      }
    },
    arbeitslosenquote () {
      let latest = this.dta.arbeitslosenzahlen.slice(-1)[0]
      // let row_lastYear = this.dta.arbeitslosenzahlen.find(el => this.isLastYear(el))
      let row_lastYear = this.dta.arbeitslosenzahlen.slice(-13)[0]

      let quote = this.decimal(latest[2])
      let diff =  Math.round((latest[2]-row_lastYear[2])*10)/10

      let change = null

      if(diff === 0) {
        change = 'grey'
        diff = '±' + diff.toString().replace('.',',')
      } else if (diff < 0) {
        change = 'green'
        diff = diff.toString().replace('.',',')
      } else {
        change = 'red'
        diff = '+' + diff.toString().replace('.',',')
      }

      return [ quote, diff, change ]
    },
    arbeitslose () {
      let latest = this.dta.arbeitslosenzahlen.slice(-1)[0]
      // let row_lastYear = this.dta.arbeitslosenzahlen.find(el => this.isLastYear(el))
      let row_lastYear = this.dta.arbeitslosenzahlen.slice(-13)[0]

      let arbeitslose = (Math.round(latest[1]/10000)/100).toString().replace('.',',')
      let percent = Math.round(((latest[1]-row_lastYear[1])/row_lastYear[1])*1000)/10

      let change = null

      if(percent === 0) {
        change = 'grey'
        percent = '±' + percent.toString().replace('.',',')
      } else if (percent < 0) {
        change = 'green'
        percent = percent.toString().replace('.',',')
      } else {
        change = 'red'
        percent = '+' + percent.toString().replace('.',',')
      }

      return [ arbeitslose, percent, change ]
    },
    stellen () {
      let latest = this.dta.arbeitslosenzahlen.slice(-1)[0]
      // let row_lastYear = this.dta.arbeitslosenzahlen.find(el => this.isLastYear(el))
      let row_lastYear = this.dta.arbeitslosenzahlen.slice(-13)[0]

      let stellen = Math.round(latest[3])/1000
      stellen = format(",.2r")(stellen).toString().replace(',','.')
      let percent = Math.round(((latest[3]-row_lastYear[3])/row_lastYear[3])*1000)/10

      let change = null

      if(percent === 0) {
        change = 'grey'
        percent = '±' + percent.toString().replace('.',',')
      } else if (percent > 0) {
        change = 'green'
        percent = '+' + percent.toString().replace('.',',')
      } else {
        change = 'red'
        percent = percent.toString().replace('.',',')
      }

      return [ stellen, percent, change ]
    },
    taetige () {
      let latest = this.dta.arbeitslosenzahlen.filter(el => el[4]>0).slice(-1)[0][4]
      latest = parseFloat(latest)
      let lastYear = this.dta.arbeitslosenzahlen.filter(el => el[4]>0).slice(-13)[0][4]
      lastYear = parseFloat(lastYear)

      let taetige = (Math.round(latest*10)/10).toString().replace('.',',')
      let percent = Math.round(((latest-lastYear)/lastYear)*1000)/10

      let change = null

      if(percent === 0) {
        change = 'grey'
        percent = '±' + percent.toString().replace('.',',')
      } else if (percent > 0) {
        change = 'green'
        percent = '+' + percent.toString().replace('.',',')
      } else {
        change = 'red'
        percent = percent.toString().replace('.',',')
      }
      
      return [ taetige, percent, change ]
    },
    chartOptions1 () {
      return {...this.chartOptions, ...this.chart1 }
    },
    chartOptions2 () {
      return {...this.chartOptions, ...this.chart2 }
    },
    chartOptions3 () {
      return {...this.chartOptions, ...this.chart3 }
    },
  }
}
</script>

<!-- <style scoped src="./assets/foundation.css">
</style> -->

<!-- <style lang="scss">
@import './assets/colors.scss';
</style>
 -->
<style lang="scss">
@import './assets/style.scss';
</style>

<style lang="scss">
div.google-visualization-tooltip {
  border: none !important;
  padding: 4px 10px !important;
  position: absolute !important;
  color: #ffffff !important;
  font-size: 14px !important;
  line-height: 1.3 !important;
  background: #363636 !important;
  border-radius: 2px !important;
  pointer-events: none !important;
  -webkit-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  -moz-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;

  ul {
    margin: 0 !important;
    padding: 0 !important;

    li {
      margin: 0 !important;
      padding: 0 !important;

      span {
        margin: 0 !important;
        padding: 0 !important;
        color: #fff !important;
        line-height: 1.5;
      }
    }
  }
}
.ctn-PlaceholderContent {
    overflow: visible;
}
</style>